import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";

import { animateScroll as scroll } from 'react-scroll';

const Navbar = () => {
    const [navbar, setNavbar] = useState(true);
    const { hash } = useLocation();
    const isActive = (iHash) => hash === iHash;

    const changeBackground = () => {
        if (window.scrollY > 0) {
            setNavbar(false);
        } else {
            setNavbar(true);
        }
    };

    window.addEventListener("scroll", changeBackground);

    useEffect(() => {
        setNavbar(true);
    }, []);

    const scrollToTop = () => {
        scroll.scrollToTop();
    }

    return (
        <div className={`${navbar
            ? "bg-white transition ease-in-out duration-300"
            : "transition ease-in-out duration-300 bg-bgPrimary text-white border-b border-b-slate-700 bg-opacity-75 backdrop-blur-md"
            } w-full fixed bg-white px-8 lg:px-0 z-50`}>
            <div className="flex justify-center py-2 lg:py-4">
                <div className="flex flex-col lg:flex-row justify-between container">
                    <div>
                        <h1 className="font-logo text-3xl mb-4 lg:mb-0 lg:text-3xl lg:py-2"><span className="text-fifth">Banraas</span>, Gili Iyang</h1>
                    </div>
                    <div className="my-auto flex flex-wrap justify-center font-semibold">
                        <NavHashLink
                            to="/#"
                            smooth="true"
                            className="px-2 lg:px-3 hover:text-fifth"
                        >
                            Home
                        </NavHashLink>
                        <NavHashLink
                            className="px-2 lg:px-3 hover:text-fifth"
                            smooth="true"
                            to="/#paket-wisata"
                            style={
                                isActive("#paket-wisata")
                                    ? {
                                        color: "#E2AA79",
                                        fontWeight: "bold",
                                        transition:
                                            "box-shadow 0.2s ease 0s, color 0.2s ease 0",
                                    }
                                    : {}
                            }
                        >
                            Paket Wisata
                        </NavHashLink>
                        <NavLink
                            className="px-2 lg:px-3 hover:text-fifth"
                            smooth="true"
                            onClick={scrollToTop}
                            to="/tentang-gili-iyang"
                        >
                            {({ isActive }) => (
                                <div className={isActive ? "text-fifth font-bold" : ""}>
                                    Tentang Gili Iyang
                                </div>
                            )}
                        </NavLink>
                        <NavHashLink
                            className="px-2 lg:px-3 hover:text-fifth"
                            smooth="true"
                            to="/#contact"
                            style={
                                isActive("#contact")
                                    ? {
                                        color: "#E2AA79",
                                        fontWeight: "bold",
                                        transition:
                                            "box-shadow 0.2s ease 0s, color 0.2s ease 0",
                                    }
                                    : {}
                            }
                        >
                            Contact Us
                        </NavHashLink>
                        <NavHashLink
                            className="px-2 lg:px-3 hover:text-fifth"
                            smooth="true">
                            Tentang Kami
                        </NavHashLink>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar;